<template>
    <div>
<!--        <BlockUI :blocked="isLoading">-->
            <ScrollPanel style="width: 98%; height: 90vh">
                <div style="height: 100%" class="p-grid p-align-start p-justify-start">
                    <Card class="p-col p-mr-5 p-ml-5">
                        <template #content>
                            <Chart type="pie" :data="chartData" :options="lightOptions" />
                        </template>
                    </Card>
                    <Card class="p-col p-mr-5 p-ml-5">
                        <template #content>

                            <DataTable
                                    style="width: 98% !important;"
                                    :rowClass="rowClass"
                                    :value="statusGrades"
                                    :paginator="false"
                                    :resizableColumns="false"
                                    columnResizeMode="fit"
                                    class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
                                    :rows="40"
                                    stateStorage="session"
                                    stateKey="menage-list-table-options"
                                    :loading="isLoading"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    :rowsPerPageOptions="[5, 10, 20, 50]"
                                    currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
                            >
                                <template #header>
                                    <div class="table-header">
                                        <div class="p-m-1 p-d-inline-flex">
                                            <!--              <span class="p-input-icon-left">-->
                                            <!--                <i class="pi pi-search" />-->
                                            <!--                <InputText-->
                                            <!--                        v-model="filters['global']"-->
                                            <!--                        placeholder="חיפוש ראשי"-->
                                            <!--                />-->
                                            <!--              </span>-->
                                        </div>

                                    </div>
                                    <h5>בעריכה או ממתין לאישור</h5>
                                </template>
                                <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>

                                <Column
                                        bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                        field="grade"
                                        header="כיתה"
                                >
                                    <template #body="slotProps">
                                        {{ getGradeName(slotProps.data.grade) }}
                                    </template>
                                </Column>

                                <Column
                                        bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                        field="lastUpdate"
                                        header="עדכון אחרון"
                                >
                                    <template #body="slotProps">
                                        {{ slotProps.data.lastUpdate ? getFullData(slotProps.data.lastUpdate) : '-'}}
                                    </template>
                                </Column>
                                <Column
                                        bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                        field="statusReport"
                                        header="סטטוס"
                                >
                                    <template #body="slotProps">
                                        <div :class="slotProps.data.reportGradeStatus">
                                            {{ getStatusFullName(slotProps.data.reportGradeStatus) }}
                                        </div>
                                    </template>
                                </Column>

                            </DataTable>
                        </template>
                    </Card>
                </div>

            </ScrollPanel>
<!--        </BlockUI>-->
    </div>
</template>

<script>
import {getReportGradeStatus} from './adminReport'
import {getGradeFullName, getPupilFullName} from "@/utils/parseObj";
import {dateToHebrewAndTime} from "@/utils/hebrewDateFormat";
import {mapState} from "vuex";

export default {
    name: "admin-list",
    data() {
        return {
            statusGrades: null,
            isLoading: false,

            lightOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                }
            }
        }
    },
    props: {
        selectedReportName: {
            type: Object
        },
    },
    watch: {
        selectedReportName(a, b) {
                this.initDAta()
        },
    },
    created() {
        // this.initDAta()

    },
    methods: {
        rowClass(data) {
            return ''
            // return data.enabled === false ? "row-unenabled" : null;
        },
        getFullData(date) {
            return dateToHebrewAndTime(date)
        },
        getUserFullName(userId) {
            let userIdFinal = userId
            if (userId !== undefined && userId.id === undefined) {
                const start = userId.indexOf('id') + 3
                const end = userId.indexOf(',')
                userIdFinal = userId.slice(start, end)
            }
            return getUserFullName(userIdFinal)
        },
        getStatusFullName(status) {
            const statusNames = {
                EMPTY: "ריק",
                EDIT: "בעריכה",
                RETURN: "חזר לתיקונים",
                WAIT_TO_ADMIN_AGREE: "ממתין לאישור מנהל",
                ADMIN_AGREE: "מאושר"
            }
            return statusNames[status] || 'ריק'
        },
        getPupilName(pupilId) {
            return getPupilFullName(pupilId)
        },
        getGradeName(gradeId) {
            return getGradeFullName(gradeId)
        },
        getDate(dateLong) {
            return dateToHebrewAndTime(dateLong)
        },
        async initDAta(){
            this.isLoading = true
           await this.getReportGradeStatus()
            this.isLoading = false

        },
        async getReportGradeStatus() {
            return new Promise(async (resolve, reject) => {
                try {
                    const reportName = this.selectedReportName.id
                    const {data} = await getReportGradeStatus(reportName)
                    this.statusGrades = data
                    resolve()
                } catch (e) {
                    reject()
                }
            })
        }
    },
    computed: {
        ...mapState([ "gradeOptions"]),
        EMPTY(){
             return this.gradeOptions?.length - this.statusGrades?.length
        }, EDIT(){
            return this.statusGrades?.filter(s => s.reportGradeStatus === "EDIT").length
        }, WAIT_TO_ADMIN_AGREE(){
            return this.statusGrades?.filter(s => s.reportGradeStatus === "WAIT_TO_ADMIN_AGREE").length
        }, ADMIN_AGREE(){
            return this.statusGrades?.filter(s => s.reportGradeStatus === "ADMIN_AGREE").length
        }, RETURN(){
            return this.statusGrades?.filter(s => s.reportGradeStatus === "RETURN").length
        },
        chartData() {
            return {
                labels: ['ריק','בעריכה','ממתין לאישור מנהל','מאושר','חזר לתיקונים'],
                    datasets: [
                    {
                        data: [
                            this.EMPTY,
                            this.EDIT,
                            this.WAIT_TO_ADMIN_AGREE,
                            this.ADMIN_AGREE,
                            this.RETURN,
                            ],
                        hoverBackgroundColor: ["#767a7b","#23547b","#8a5340","#256029","#c63737"],
                        backgroundColor: ["#d2d2d2","#b3e5fc","#feedaf","#c8e6c9","#ffcdd2"]
                    }
                ]
            }
        }
    },
}
</script>

<style scoped>
>>> .p-card {
    justify-content: center;
    display: flex;
    align-items: center;
}

.RETURN{
    background-color: #ffcdd2;
    color: #c63737;
}

.ADMIN_AGREE{
    background: #c8e6c9;
    color: #256029;
}

.WAIT_TO_ADMIN_AGREE{
    background: #feedaf;
    color: #8a5340;
}

.EDIT{
    background-color: #b3e5fc;
    color: #23547b;
}
</style>